import * as actions from '../actionTypes';
import { GET_SUBJECT_INSTANCES, ADD_SUBJECT_INSTANCE, UPDATE_SUBJECT_INSTANCE, DELETE_SUBJECT_INSTANCE, GET_ATTENDANCE_CODE, SET_SELECTED_SUBJECT_INSTANCE } from '../api';
import client from '../apolloClient';
import { deleteEnrollment } from './enrollmentActions';
import { setAssignments, deleteAssignment } from './assignmentsActions';
import { setSelectedSubjectInstance, unsetSelectedSubjectInstance } from './selectionActions';
import { cleanAttendances } from './attendanceActions';
import { setDoneLoading } from '../actions/loadingActions';
import { setAttendanceModified } from './loadingActions';

export const deleteSubjectInstance = (subjectInstance_id) => async (dispatch, getState) => {
    try {

        const state = getState();
        const subjectInstance = state.subjectInstances.find(sub => sub._id === subjectInstance_id);
        if (subjectInstance) {
            const assignmentIds = state.assignments
                .filter(as => subjectInstance_id == as.subjectInstance._id)
                .map(as => as._id);
        
            const grades = state.grades.filter(gr =>
                assignmentIds.includes(gr.assignment._id)
            );
       
            const enrollmentIds = state.enrollments
                .filter(en => subjectInstance_id == en.subjectInstance._id)
                .map(en => en._id);
       
            const attendances = state.attendances.filter(at =>
                enrollmentIds.includes(at.enrollment._id)
            );
         
            assignmentIds.forEach(assignmentId => {
                const action = { type: actions.DELETE_ASSIGNMENT, payload: assignmentId };
                dispatch(action);
            });
            grades.forEach(grade => {
                const action = { type: actions.DELETE_GRADE, payload: grade._id };
                dispatch(action);
            });
            enrollmentIds.forEach(enrollmentId => {
                const action = { type: actions.DELETE_ENROLLMENT, payload: enrollmentId };
                dispatch(action);
            });

            attendances.forEach(attendance => {
                const action = { type: actions.DELETE_ATTENDANCE, payload: attendance._id };
                dispatch(action);
            });
        }

        await client.mutate({
            mutation: DELETE_SUBJECT_INSTANCE,
            variables: { input: subjectInstance_id },
        });
        const action = { type: actions.DELETE_SUBJECT_INSTANCE, payload: subjectInstance_id };
        dispatch(action);

    } catch (error) {
        console.log(error);
    }
}

export const setSubjectInstances = () => async (dispatch) => {
    try {
        const { data } = await client.query({
            query: GET_SUBJECT_INSTANCES,
        });
        const subjectInstances = data.subjectInstances;
        let uniqueAssignments = [];
        subjectInstances.forEach((subjectInstance) => {
            if (subjectInstance.assignments && subjectInstance.assignments.length > 0) {
                subjectInstance.assignments.forEach((assignment) => {
                    const isAssignmentInArray = uniqueAssignments.some(
                        (item) => item._id === assignment._id
                    );
                    if (!isAssignmentInArray) {
                        const completeAssignment = { ...assignment, subjectInstance: subjectInstance };
                        uniqueAssignments.push(completeAssignment);
                    }
                });
            }
        });

        if (uniqueAssignments.length > 0) {
            dispatch(setAssignments(uniqueAssignments));
        }

        const action = { type: actions.SET_SUBJECT_INSTANCES, payload: subjectInstances };
        dispatch(action);
        // dispatch(setDoneLoading(true));
        // localStorage.setItem('doneLoading', true);
    } catch (error) {
        console.log(error);
    }
}
export const setSubjectInstancesLocally = (subjectInstances) => async (dispatch) => {
    try {
        let uniqueAssignments = [];
        subjectInstances.forEach((subjectInstance) => {
            if (subjectInstance.assignments && subjectInstance.assignments.length > 0) {
                subjectInstance.assignments.forEach((assignment) => {
                    const isAssignmentInArray = uniqueAssignments.some(
                        (item) => item._id === assignment._id
                    );
                    if (!isAssignmentInArray) {
                        const completeAssignment = { ...assignment, subjectInstance: subjectInstance };
                        uniqueAssignments.push(completeAssignment);
                    }
                });
            }
        });
        if (uniqueAssignments.length > 0) {
            dispatch(setAssignments(uniqueAssignments));
        }

        const action = { type: actions.SET_SUBJECT_INSTANCES, payload: subjectInstances };
        dispatch(action);

    } catch (error) {
        console.log(error);
    }
}




export const addSubjectInstance = (subjectInstance) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: ADD_SUBJECT_INSTANCE,
            variables: { input: subjectInstance },
        });
        const savedSubjectInstance = data.createSubjectInstance;
        const action = { type: actions.ADD_SUBJECT_INSTANCE, payload: savedSubjectInstance };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}

export const updateSubjectInstance = (subjectInstance) => async (dispatch) => {
    try {
        const { data } = await client.mutate({
            mutation: UPDATE_SUBJECT_INSTANCE,
            variables: { input: subjectInstance },
        });
        const updatedSubjectInstance = data.updateSubjectInstance;

        const action = { type: actions.UPDATE_SUBJECT_INSTANCE, payload: updatedSubjectInstance };
        dispatch(action);
    } catch (error) {
        console.log(error);
    }
}
export const getAttendanceCode = (subjectInstance) => async (dispatch) => {
    try {
        await dispatch(unsetSelectedSubjectInstance())

        if (!subjectInstance.code) {
            const { data } = await client.mutate({
                mutation: GET_ATTENDANCE_CODE,
                variables: { input: subjectInstance._id },
            });
            console.log(data);
            const code = data.generateAttendanceCode;
            if (code.isaNewCode) {
                await dispatch(setAttendanceModified(true));
                // await dispatch(cleanAttendances())
            }
            const action = { type: actions.GET_ATTENDANCE_CODE, payload: { subjectInstance, code } };
            await dispatch(action);
            const updatedSubjectInstance = { ...subjectInstance, code: code.code };
            await dispatch(setSelectedSubjectInstance(updatedSubjectInstance));

        } else {
            await dispatch(setSelectedSubjectInstance(subjectInstance));
        }

    } catch (error) {
        console.log(error);
    }
}
